(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation-supermarket"]) return;
  try {
    
  // Mobile-only announcement slider
  (function() {
    var slidesWrap = document.getElementById('mobileAnnounceSlides');
    if (!slidesWrap) return;
    var slides = slidesWrap.querySelectorAll('.mobile-announce-slide');
    if (slides.length < 2) return;

    var current = 0;

    function nextSlide() {
      if (window.innerWidth >= 768) return;
      slides[current].classList.remove('active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('active');
    }

    setInterval(nextSlide, 3000);
  })();

  // Mega menu category logic
  document.addEventListener('DOMContentLoaded', function() {
    var categoryNavItems = document.querySelectorAll('.cat-nav li');
    var innerWrappers = document.querySelectorAll('.inner-wrapper');
    var categoryImageLinks = document.querySelectorAll('.category-image');

    function hideAllSectionsAndImages() {
      innerWrappers.forEach(function(wrapper) {
        wrapper.style.display = 'none';
      });
      categoryImageLinks.forEach(function(link) {
        link.style.display = 'none';
      });
    }

    function setActiveCategory(targetId) {
      hideAllSectionsAndImages();

      var activeWrapper = document.getElementById(targetId);
      if (activeWrapper) {
        activeWrapper.style.display = 'flex';
      }

      var activeImageLink = document.querySelector("a[id='" + targetId + "']");
      if (activeImageLink) {
        activeImageLink.style.display = 'block';
      }

      categoryNavItems.forEach(function(item) {
        item.classList.remove('active');
        if (item.getAttribute('data-target') === targetId) {
          item.classList.add('active');
        }
      });
    }

    setActiveCategory('category-1');

    categoryNavItems.forEach(function(item) {
      item.addEventListener('click', function() {
        var targetId = item.getAttribute('data-target');
        setActiveCategory(targetId);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
